/* eslint-disable max-lines -- this file contains too many lines after rules update, this need to be refactored */
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input,
	NgZone, QueryList, ViewChildren, ElementRef,
	OnDestroy, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators, FormsModule,
	ReactiveFormsModule,
	ValidationErrors,
	ValidatorFn } from '@angular/forms';
import { catchError, Observable, of, Subscription } from 'rxjs';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { trigger, transition, animate, style } from '@angular/animations';
import { Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor, NgClass, DecimalPipe } from '@angular/common';

import { DialogProductDetailsComponent } from '../product-details/product-details.component';
import { DialogNeed4SteelOrderHistoryComponent } from '../need4steel-order-history/need4steel-order-history.component';
import { MillOfferNeed4Steel, DPLScopeConstraints, Variable, TOLERANCE_FIELD, MillOrder,
	DPLConstraintGroup, ListValue, WeightType, MillOrderPriceResponse, N4sEventsProductData,
	ProductDetails, PRICE_DEFAULT, ValueRange, OfferRequest,
	DplScope, OrderHistory,
	NumericRange,
	LogisticsConstraints, isVariableSpecificField, METAL_STUDS,
	DEFAULT_TRANSPORT_MODE, DEFAULT_INCOTERM } from '../../../models/need4steel';
import { TemplateDescription, UfoProductSimulationResponse } from '../../../../product/models/product';
import { ProductConfiguration } from '../../../../product/models/product-configuration';
import { FieldValueObject } from '../../../../product/components/cards/product-card/utils/field/field';
import { Need4SteelService } from '../../../services/need4steel.api.service';
import { FormNeed4SteelOffer } from '../../../models/form-mill-offer';
import { Need4SteelWizardService } from '../../../services/need4steel-wizard.service';
import { MillOfferService } from '../../../services/mill-offer.service';
import { Need4SteelHelperService } from '../../../services/need4steel-helper-service';
import { TranslationService } from '../../../../shared/services/translation.service';
import { UserService } from '../../../../shared/services/user.service';
import { UsageEvent, Need4steelEventsProductData } from '../../../../shared/models/usage-event';
import { CodeValue } from '../../../../shared/models/code-value';
import { UsageAnalytics } from '../../../../shared/services/usage-analytics.service';
import {
	NAMESPACE_A2C_FIELD,
	ProductCharacteristicsTranslationService
} from '../../../../shared/services/product-characteristics-translation.services';
import { formatDimension, formatNumber } from '../../../../shared/utils/number.format';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';
import { InputNumberDirective } from '../../../../shared/directives/input-number.directive';
import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';
import { uuidv4 } from '../../../../shared/utils/uuid';
import { CoilCalculator, CoilCalculatorResult } from '../../../../calculator/models/coil-calculator';
import { HOT_OR_COLD_ROLLED } from '../../../../calculator/models/coil-calculator-constants';
import { CoilCalculatorService } from '../../../../calculator/services/coil-calculator.service';

interface WidthDplScope {
	mode: 'none' | 'list' | 'range';
	constraints: DPLConstraintGroup['settings'];
	discreteValues: number[];
	min: number;
	max: number;
	minExcluded: boolean;
	maxExcluded: boolean;
}

@Component({
	selector: 'copo-step-product-specification',
	templateUrl: './step-product-specification.component.html',
	styleUrl: './step-product-specification.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('deleteItemTrigger', [
			transition(':leave', [
				animate(750, style({
					opacity: 0,
					height: 0,
				}))
			])
		])
	],
	imports: [
		NgIf,
		MatFormFieldModule,
		TranslateModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		NgFor,
		MatOptionModule,
		MatButtonModule,
		FocusMeDirective,
		MatIconModule,
		MatTooltipModule,
		MatInputModule,
		InputNumberDirective,
		MatMenuModule,
		NgClass,
		LoadingSpinnerComponent,
		MatDividerModule,
		DecimalPipe,
		NumberPipe
	]
})

export class StepProductSpecificationComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChildren('rows') rows!: QueryList<ElementRef<HTMLElement>>;
	@Input() millOfferData?: MillOfferNeed4Steel;
	@Input() shipToEvents?: Observable<void>;

	readonly FIELD_LIST = new Set([
		'soldTo',
		'shipTo',
		'shipToParty',
		'endUser',
		'steelGrade',
		'thicknessValue',
		'widthValue',
		'maxNetWeightValue'
	]);

	readonly OPTIONAL_VARIABLE_FIELDS = new Set(['additionalTest']);

	form!: FormNeed4SteelOffer;
	productsCount = 1;
	productFormGroup!: FormGroup;
	steelGrades: string[] = [];
	isLoading = true;
	disabled = true;
	isSoldtoSelected = false;
	secondRowVariables?: Variable[] = [];
	preSelectedSteelGrade?: string;
	coilCalculatorResultSubscription: Subscription | undefined;
	a2CSimulationSubscriptionArr?: Subscription[] = [];
	priceRequestSubscriptionArr?: Subscription[] = [];
	a2CSimulationSubscription?: Subscription;
	toleranceField = TOLERANCE_FIELD;
	mill!: string;
	millSiteCode!: string;
	priceRequestSubscription?: Subscription;
	millPrice: number | undefined;
	eventsSubscription?: Subscription;
	scrollEventSubscription?: Subscription;
	exchangeRateSubscription?: Subscription;
	offerRequestSubsc?: Subscription;
	orderHistoryImportSub?: Subscription;
	simulationResponseList: Map<string, ProductDetails>[] = [];
	maxSpecCoilWeightOptionAvailable = false;
	maxCoilWeightMin = 0;
	maxCoilWeightMax = 0;
	isThicknessListOfValues = false;
	isPriceRequest = false;
	largeScreen = true;
	requestObject: DplScope | undefined;
	coilCalculatorResult: CoilCalculatorResult = new CoilCalculatorResult();
	weightTypes: WeightType[] = [
		{ code: 'maxNetWeightValue', value: 'Max coil weight' },
		{ code: 'maxWeightPerWidthUnitValue', value: 'kg/mm' }
	];

	priceDefaultValue = PRICE_DEFAULT;
	isMaxCoilWeightLogisticRulesExists = false;
	packagingOptions = new Set<string>();
	soldToChangeSubscription: Subscription;
	endUserChangeSubscription: Subscription;
	private readonly widthScopeCache = new Map<string, WidthDplScope>();

	constructor(
		public fb: FormBuilder,
		public changeDetectorRef: ChangeDetectorRef,
		private readonly need4SteelService: Need4SteelService,
		private readonly coilCalculatorService: CoilCalculatorService,
		private readonly need4steelWizardService: Need4SteelWizardService,
		private readonly millOfferService: MillOfferService,
		private readonly need4steelHelperService: Need4SteelHelperService,

		private readonly dialog: MatDialog,
		public usageAnalytics: UsageAnalytics,
		private readonly router: Router,
		readonly ngZone: NgZone,
		private readonly userService: UserService,
		private readonly translationService: TranslationService,
		private readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService
	) {
		this.createOrLoadN4SForm();
		this.form = this.need4steelWizardService.getStateOfferForm();
		this.a2CSimulationSubscriptionArr = [];
		this.priceRequestSubscriptionArr = [];
		this.soldToChangeSubscription = this.need4steelWizardService
			.onsoldToChangeEventSubscribe().subscribe(result => {
				if (result) {
					this.isSoldtoSelected = true;
					this.isPastOrderHistoryAvailable();
					if (this.requestObject) {
						this.requestObject.soldTo = result;
					}
				}
			});
		this.endUserChangeSubscription = this.need4steelWizardService
			.onEndUserChangeEventSubscribe().subscribe(() => {
				this.resetPricesForEndUserChange();
			});
	}

	get productResultControl() {
		return (<FormArray> this.productFormGroup.controls['productSpecifications']).controls;
	}

	get productFormArray() {
		return <FormArray> this.productFormGroup.get('productSpecifications');
	}

	@HostListener('window:resize') onResize() {
		this.largeScreen = innerWidth > 1280;
	}

	getMillOfferScopeData(
		dplconstraintsList: DPLScopeConstraints[],
		category: string,
		subCategory: string,
		dealType: string
	) {
		return {
			soldTo: <string> this.form.controls['soldTo'].value,
			productCategory: category,
			productSubCategory: subCategory,
			dealType,
			constraintGroups: dplconstraintsList.map(group => {
				const constraints = group.settingGroups.map(settingGroup => {
					const combinedConstraints: Record<string, string[] | ValueRange> = {};
					for (const setting of settingGroup.settings) {
						const fieldName = setting.fieldName[0].toLowerCase() + setting.fieldName.slice(1);
						// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
						combinedConstraints[fieldName] = setting.attributeValues?.map(attr => attr.code) ?? {
							minValue: setting.minValue,
							maxValue: setting.maxValue,
							minValueExcluded: setting.minValueExcluded,
							maxValueExcluded: setting.maxValueExcluded
						};
					}
					return combinedConstraints;
				});
				return { constraints };
			})
		};
	}

	createOrLoadN4SForm() {
		if (this.millOfferService.productFormGroup) {
			this.productFormGroup = this.millOfferService.productFormGroup;
			for (let i = 0; i < this.productFormArray.length; i++) {
				const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
				control.controls[i].get('variableFormGroup')?.enable();
			}
			this.productsCount = this.productFormArray.length;
		} else {
			this.productFormGroup = new FormGroup({
				productSpecifications: new FormArray([]),
			});
			this.millOfferService.productFormGroup = this.productFormGroup;
		}
	}

	onSteelgradeChange(event: MatSelectChange, formArrindex: number) {
		const selectedSteelGrade = <string> event.value;
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		if ((<File[]>(<FormControl> controlArray.controls[formArrindex].get('steelGrade')).value).length === 1) {
			(<FormControl> controlArray.controls[formArrindex].get('steelGrade')).setValue(selectedSteelGrade, {
				onlySelf: true
			});
		}
		const steelGradeControl = <FormControl> controlArray.controls[formArrindex].get('steelGrade');
		const thicknessCtrl = <FormControl> controlArray.controls[formArrindex].get('thickness');
		if (steelGradeControl.value === '' && steelGradeControl.value === null) {
			return;
		}
		const { min, max, minExcluded, maxExcluded } = this.refreshThicknessMinMax(formArrindex);
		const belowMinBound = minExcluded ? thicknessCtrl.value <= min : thicknessCtrl.value < min;
		const aboveMaxBound = maxExcluded ? thicknessCtrl.value >= max : thicknessCtrl.value > max;
		if (belowMinBound || aboveMaxBound || thicknessCtrl.invalid) {
			controlArray.controls[formArrindex].get('thickness')?.setValue('');
		}
		const widthControl = <FormControl> controlArray.controls[formArrindex].get('width');
		const { min: minW, max: maxW, minExcluded: minExcludedW, maxExcluded: maxExcludedW } =
			this.refreshWidthMinMax(formArrindex);
		const belowMinBoundW = minExcludedW ? widthControl.value <= minW : widthControl.value < minW;
		const aboveMaxBoundW = maxExcludedW ? widthControl.value >= maxW : widthControl.value > maxW;
		if (belowMinBoundW || aboveMaxBoundW || widthControl.invalid || thicknessCtrl.value === '') {
			controlArray.controls[formArrindex].get('width')?.setValue('');
			controlArray.controls[formArrindex].get('configErrMsg')?.setValue('');
			controlArray.controls[formArrindex].get('price')?.setValue(PRICE_DEFAULT);
		}
	}

	ngOnInit() {
		this.largeScreen = innerWidth > 1280;
		if (this.millOfferData) {
			this.populateAvailableSteelgrades();
			if (this.millOfferData.dplconstraintsList) {
				this.requestObject = this.getMillOfferScopeData(
					this.millOfferData.dplconstraintsList,
					this.millOfferData.category,
					this.millOfferData.subCategory,
					this.millOfferData.dealType
				);
			}
			this.mill = this.millOfferData.millSite || '';
			this.millSiteCode = this.millOfferData.millSiteCode || '';
			this.buildSecondRowVariableFields(this.millOfferData.variablesList || []);
			const templateVariablesList = this.millOfferData.variablesList || [];
			this.millOfferService.noWeightOption = false;
			this.isThicknessListOfValues = this.checkIfFieldContainsListOfValues('thicknessvalue');
			this.widthScopeCache.clear();
			this.maxSpecCoilWeightOptionAvailable = templateVariablesList
				.filter(variable => variable.field === 'maxWeightPerWidthUnitValue').length === 1;
			this.millOfferService.maxSpecCoilWeightOptionAvailable = this.maxSpecCoilWeightOptionAvailable;
			const maxCoilWeightOption = templateVariablesList
				.filter(variable => variable.field === 'maxNetWeightValue').length === 1;
			if (!this.maxSpecCoilWeightOptionAvailable && !maxCoilWeightOption) {
				this.millOfferService.noWeightOption = true;
				this.router.navigate(['/need4steel/offerlist'], { replaceUrl: true })
					.catch((err: unknown) => {
						console.error(err);
					});
			}
			[this.maxCoilWeightMin, this.maxCoilWeightMax] = this.getMaxCoilWeightRanges();
		}
		this.loadExchangeRateIfNeeded();
		// Initialize product form with one empty product item and disable all fields of the product form
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		if (control.length < 1) {
			control.push(this.initProductResult());
		}
		this.eventsSubscription = this.shipToEvents?.subscribe(() => {
			this.processLogesticalRoutesRules();
		});
		if (this.form.getFormShipTo().value) {
			this.processLogesticalRoutesRules();
		}
		if (this.form.getFormSoldTo().value) {
			this.isSoldtoSelected = true;
			this.isPastOrderHistoryAvailable();
		}
		this.scrollEventSubscription = this.need4steelWizardService.getTriggerScrollObservable().subscribe(index => {
			this.scrollToRow(index);
		});
	}

	hasExchangeRateToDisplay() {
		return this.need4steelWizardService.hasExchangeRateToDisplay();
	}

	getExchangeRateValue() {
		const currency = this.need4steelWizardService.getInvoicingCurrency();
		if (!currency) {
			return '';
		}
		const exchangeRate = this.need4steelWizardService.getExchangeRate(currency);
		return exchangeRate ? formatNumber(exchangeRate.value, 'amount') : '';
	}

	getExchangeRateCurrency() {
		return this.need4steelWizardService.getInvoicingCurrency() || '';
	}

	getExchangeRateReferenceDate() {
		return this.need4steelWizardService.getExchangeRateReferenceDate() || '';
	}

	getPriceNumber(formIndex: number): number {
		return Number(this.getPrice(formIndex));
	}

	getEstimatedPrice(formIndex: number): string {
		const currency = this.need4steelWizardService.getInvoicingCurrency();
		if (!currency) {
			return '';
		}
		const exchangeRate = this.need4steelWizardService.getExchangeRate(currency);
		if (!exchangeRate) {
			return '';
		}
		const price = this.getPriceNumber(formIndex);
		if (!Number.isFinite(price)) {
			return '';
		}
		return `${ formatNumber(Math.round(price * exchangeRate.value * 100) / 100, 'amount') } ${ currency }`;
	}

	processLogesticalRoutesRules() {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		const selectedCountry = this.millOfferService.filteredSoldtoShiptoList?.find(item =>
			item.businessId === this.form.getFormShipTo().value)?.countryCode;
		const logisticalRoutes = this.millOfferService.logisticalRoutes
			.filter(route => route.countryCode === selectedCountry);
		this.getMaxCoilWeightLogisticsRules(logisticalRoutes);
		this.packagingOptions = this.getPackagingLogisticsRules(logisticalRoutes);
		for (let i = 0; i < control.length; i++) {
			this.processLogisticsConstraints(i);
			this.prepareDataAndCallForSimulateA2Cproduct(i);
		}
	}

	getMaxCoilWeightLogisticsRules(filteredRoutes: LogisticsConstraints[]) {
		const [, max] = this.getMaxCoilWeightRanges();
		let resetMaxCoilWeightRange = false;
		if (filteredRoutes.length > 0) {
			const maxCoilWeightRestrictions = <number[]>filteredRoutes
				.map(route => route.maxCoilWeight).filter(Boolean);
			if (maxCoilWeightRestrictions.length > 0) {
				this.maxCoilWeightMax = Math.min(max, ...maxCoilWeightRestrictions);
				this.isMaxCoilWeightLogisticRulesExists = true;
			} else {
				resetMaxCoilWeightRange = true;
			}
		} else {
			resetMaxCoilWeightRange = true;
		}

		if (resetMaxCoilWeightRange) {
			this.maxCoilWeightMax = max;
			this.isMaxCoilWeightLogisticRulesExists = false;
		}
	}

	getPackagingLogisticsRules(filteredRoutes: LogisticsConstraints[]): Set<string> {
		return new Set(filteredRoutes
			.filter(route => {
				const routeFamily = `${ route.category }${ route.subCategory }${ route.form }`;
				const millOfferFamily = `${ this.millOfferData?.category }${ this.millOfferData?.subCategory }`
					+ `${ this.millOfferData?.form }`;
				return routeFamily === millOfferFamily;
			})
			.map(route => route.packagingCode)
			.filter((code): code is string => code !== undefined));
	}

	processLogisticsConstraints(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');

		const maxCoilWeightControl = <FormControl>controlArray.controls[index].get('maxCoilWeight');
		this.updateMaxCoilWeightValidators(maxCoilWeightControl);
		if (this.secondRowVariables?.some(variable => variable.field === 'packagingCode')) {
			const packagingFormControl = <FormControl>controlArray.controls[index]
				.get('variableFormGroup')?.get('packagingCode');

			this.updatePackagingValidators(packagingFormControl, index);
		}
	}

	updateMaxCoilWeightValidators(maxCoilWeightControl: FormControl): void {
		maxCoilWeightControl.setValidators([
			Validators.required,
			Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
			Validators.max(this.maxCoilWeightMax),
			Validators.min(this.maxCoilWeightMin)
		]);
		maxCoilWeightControl.updateValueAndValidity();
	}

	updatePackagingValidators(packagingFormControl: FormControl, index: number): void {
		packagingFormControl.setValidators([
			Validators.required,
			...this.packagingOptions.size > 0 ? [this.evaluatePackagingRules(index)] : []
		]);
		packagingFormControl.updateValueAndValidity();
	}

	evaluatePackagingRules(index: number): ValidatorFn {
		return (_control: AbstractControl): ValidationErrors | null => {
			const packagingCode = this.getFieldCode(index, 'packagingCode');

			if (packagingCode && this.packagingOptions.size > 0 && !this.packagingOptions.has(packagingCode)) {
				return { invalid: true };
			}
			return null;
		};
	}

	checkLogisticsConstraints(index: number): boolean {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		let maxCoilError;
		if (this.maxSpecCoilWeightOptionAvailable && this.getWeightType() === 'maxWeightPerWidthUnitValue') {
			const maxSpecificWeightControl = <FormControl> controlArray.controls[index].get('maxSpecificWeight');
			maxCoilError = Boolean(maxSpecificWeightControl.errors?.['max']
				&& this.isMaxCoilWeightLogisticRulesExists);
		} else {
			const maxCoilWeightControl = <FormControl> controlArray.controls[index].get('maxCoilWeight');
			maxCoilError = Boolean(maxCoilWeightControl.errors?.['max']
				&& this.isMaxCoilWeightLogisticRulesExists);
		}

		const packagingError = this.secondRowVariables?.some(variable => variable.field === 'packagingCode')
			? this.isNotValidConstraints(index, 'packagingCode')
			: false;
		const hasErrors = packagingError || maxCoilError;
		this.handlePackagingAndWeightErrors(index, hasErrors);
		return hasErrors;
	}

	isNotValidConstraints(index: number, field: string): boolean {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[index].get('variableFormGroup')?.get(field);
		return <string>fieldControl.value ? fieldControl.invalid : false;
	}

	handlePackagingAndWeightErrors(index: number, hasErrors: boolean): void {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const configErrMsgControl = <FormControl> controlArray.controls[index].get('configErrMsg');
		if (hasErrors) {
			configErrMsgControl.setValue(this.translationService.getTR('need4steel-logistic-routes.errormsg'));
			const loaderControl = <FormControl>controlArray.controls[index].get('loader');
			const isPriceControl = <FormControl>controlArray.controls[index].get('price');
			loaderControl.setValue('false');
			isPriceControl.setValue('');
			this.changeDetectorRef.detectChanges();
		} else {
			configErrMsgControl.setValue('');
		}
	}

	scrollToRow(index: number) {
		const rowItems = this.rows.toArray();
		if (index !== -1 && rowItems[index]) {
			rowItems[index].nativeElement.scrollIntoView();
		}
	}

	checkIfFieldContainsListOfValues(fieldName: string) {
		if (this.millOfferData?.dplconstraintsList) {
			const dplConstraints = this.millOfferData.dplconstraintsList
				.flatMap(item => item.settingGroups)
				.flatMap(v => v.settings)
				.filter(v => v.fieldName.toLowerCase() === fieldName);
			if (dplConstraints.length > 0) {
				for (const field of dplConstraints) {
					if (field.minValue === field.maxValue) {
						return true;
					}
				}
			}
		}
		return false;
	}

	populateAvailableSteelgrades() {
		this.steelGrades = [];
		if (this.millOfferData?.dplconstraintsList) {
			this.steelGrades = this.millOfferData.dplconstraintsList
				.flatMap(item => item.settingGroups)
				.flatMap(v => v.settings)
				.filter(v => v.fieldName.toLowerCase() === 'steelgrade')
				.flatMap(v => v.attributeValues)
				.map(v => v.description)
				.filter((value, index, self) => self.indexOf(value) === index)
				.sort((a, b) => a.localeCompare(b));
			if (this.steelGrades.length === 1) {
				this.preSelectedSteelGrade = this.steelGrades[0];
			}
		}
	}

	buildSecondRowVariableFields(templateVariables: Variable[]) {
		if (this.millOfferData?.dplconstraintsList) {
			// filter variable from A2C template which are not header or 1st row
			const secondRowTemplateVariables = templateVariables.filter(v => !this.FIELD_LIST.has(v.field));
			// get a list of all fields define on the offer line level in CRM
			const constraintKeysDefinedInN4SOffer: string[] = this.millOfferData.dplconstraintsList
				.flatMap(v => v.settingGroups)
				.flatMap(v => v.settings)
				.map(v => v.fieldName)
				.filter((value, index, self) => self.indexOf(value) === index);
			// filter template variables which are defined in the offer line and in the template => variable list
			this.secondRowVariables = secondRowTemplateVariables
				.filter(v => this.isVariableSpecific(v.field)
					|| constraintKeysDefinedInN4SOffer.find(c => c.toLowerCase() === v.field.toLowerCase()))
				.sort((a, b) => {
					if (a.field === 'millTestCertificate' && b.field === 'additionalTest') {
						return -1;
					}
					if (a.field === 'additionalTest' && b.field === 'millTestCertificate') {
						return 1;
					}
					return a.fieldDescription > b.fieldDescription ? 1 : -1;
				});
		}
	}

	refreshThicknessMinMax(index: number): NumericRange {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const selectedSteelGrade = String((<FormControl>controlArray.controls[index].get('steelGrade')).value);
		if (this.millOfferData?.dplconstraintsList) {
			// find DPLScopes where setting inside is matching selected steelgrade
			const dplScopes = this.millOfferData.dplconstraintsList
				.filter(value => this.dplScopeHasKeyValue(value, 'steelgrade', selectedSteelGrade));
			const thicknessConstraints = dplScopes
				.flatMap(v => v.settingGroups)
				.flatMap(item => item.settings)
				.filter(v => v.fieldName.toLowerCase() === 'thicknessvalue');
			if (thicknessConstraints.length > 0) {
				const thicknessMinValue = thicknessConstraints
					.reduce((prev, curr) => prev.minValue > curr.minValue
						|| (prev.minValue === curr.minValue && !curr.minValueExcluded) ? curr : prev);
				const thicknessMaxValue = thicknessConstraints
					.reduce((prev, curr) => prev.maxValue < curr.maxValue
						|| (prev.maxValue === curr.maxValue && !curr.maxValueExcluded) ? curr : prev);
				return {
					min: thicknessMinValue.minValue,
					max: thicknessMaxValue.maxValue,
					minExcluded: thicknessMinValue.minValueExcluded,
					maxExcluded: thicknessMaxValue.maxValueExcluded
				};
			}
		}
		return { min: 0, max: 0, minExcluded: true, maxExcluded: true };
	}

	addCustomFormControl() {
		this.productFormGroup.addControl('productSpecifications', new FormArray([]));
	}

	addProductResult() {
		this.productsCount += 1;
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		control.push(this.initProductResult());
		this.millOfferService.simulationResponseList.push(new Map<string, ProductDetails>());
	}

	async removeProductResult(index: number) {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		if (!this.userService.user.readOnly) {
			const price = control.controls[index].get('price');
			if (price?.value !== '─' || price.value !== null || price.value !== '') {
				await this.ngZone.runOutsideAngular(async () => {
					await this.sendN4SData(index, 'REMOVE', '', '');
				});
			}
		}
		control.removeAt(index);
		this.millOfferService.simulationResponseList.splice(index, 1);
		this.productsCount -= 1;
	}

	async sendN4SData(index: number, eventType: string, isFeasible: string, requestSimuPriceNumber: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = Number(<FormControl>controlArray.controls[index].get('width')?.value);
		const thicknessValue = Number(<FormControl>controlArray.controls[index].get('thickness')?.value);
		const soldToParty = String(this.form.getFormSoldTo().value).padStart(10, '0');
		const shipToParty = String(this.form.getFormShipTo().value).padStart(10, '0');
		const itemNumber = String(index + 1).padStart(3, '0');
		const steelGradeValue = this.getSteelGradeCode(index);
		const deliveryWeek = String(this.millOfferData?.deliveryWeek);
		const deliveryYear = String(this.millOfferData?.deliveryYear);
		const dealType = this.millOfferData?.dealType;
		const maxcoilweight = Number(<FormControl>controlArray.controls[index].get('maxCoilWeight')?.value);
		const maxSpecificWeight = <FormControl>controlArray.controls[index].get('maxSpecificWeight')?.value;
		const coils = Number(<FormControl>controlArray.controls[index].get('coil')?.value);
		const price = <FormControl>controlArray.controls[index].get('price')?.value;
		const priceValue = price.value ? Number(price) : undefined;
		const milltestCertificate = this.getFieldCode(index, 'millTestCertificate');
		const total = this.getTotalWeight(index);
		const sqnNumberControl = <FormControl>controlArray.controls[index].get('sqnNumber')?.value;
		const eventsProductDataList: Need4steelEventsProductData[] = [];
		const variableFormControl = <FormControl>controlArray.controls[index].get('variableFormGroup');
		const variableGroup = <FormControl>variableFormControl.value;

		let thicknesstol;
		const varFieldKeys = Object.keys(variableGroup);
		for (const field of varFieldKeys) {
			if (field === 'thicknessTolerance') {
				thicknesstol = this.getFieldCode(index, 'thicknessTolerance');
			}
			const variableCode = this.getFieldCode(index, field);
			const fieldName = field;
			const eventsProductData: Need4steelEventsProductData = {
				characName: fieldName,
				characValueText: variableCode,
			};
			eventsProductDataList.push(eventsProductData);
		}
		const usageEvent: UsageEvent = {
			code: eventType,
			soldto: soldToParty,
			offerWeek: 'W'.concat(`${ deliveryWeek }/${ deliveryYear }`),
			offerProduct: this.millOfferData?.category,
			offerProductForm: this.millOfferData?.form,
			offerProductName: this.millOfferData?.subCategory,
			offerMill: this.millOfferData?.millSite,
			offerRfq: this.millOfferData?.rfqNumber,
			// eslint-disable-next-line @typescript-eslint/no-base-to-string
			offerSqn: String(sqnNumberControl),
			item: String(itemNumber),
			shipto: shipToParty,
			steelgrade: steelGradeValue,
			thickness: Number(thicknessValue),
			width: Number(widthControl),
			maxCoilWeight: Number(maxcoilweight),
			maxSpeCoilWeight: Number(maxSpecificWeight) > 0 ? Number(maxSpecificWeight) : undefined,
			nbOfCoil: coils,
			price: priceValue,
			testCertificate: milltestCertificate,
			thicknessTol: thicknesstol === '' ? undefined : thicknesstol,
			totalWeight: Number(total),
			need4steelProductDataList: eventsProductDataList,
			feasible: isFeasible,
			requestSimuPriceNumber,
			dealType,
			codeUnitRef: this.millOfferService.boc.referenceCommercialUnit?.codeUnit || undefined,
			codeSubUnitRef: this.millOfferService.boc.referenceCommercialSubUnit?.codeSubUnit || undefined,
			codeSubSubUnitRef: this.millOfferService.boc.referenceCommercialSubSubUnit?.codeSubSubUnit || undefined,
			transportMode: <string> this.form.getFormTmode().value || DEFAULT_TRANSPORT_MODE,
			incoterms: <string> this.form.getFormIncoterm().value || DEFAULT_INCOTERM
		};
		await this.usageAnalytics.sendUsageAnalyticsEvent(usageEvent);
	}

	initProductResult() {
		const variableGroup: Record<string, AbstractControl> = {};
		if (this.secondRowVariables) {
			for (const variable of this.secondRowVariables) {
				if (this.isVariableSpecific(variable.field)) {
					variableGroup[variable.field] =
					this.millOfferData?.dealType === 'P' ? new FormControl({ value: '', disabled: true })
						: new FormControl({ value: METAL_STUDS, disabled: true }, { nonNullable: true });
				} else {
					variableGroup[variable.field] = this.OPTIONAL_VARIABLE_FIELDS.has(variable.field) ? new FormControl(
						{ value: '', disabled: true }
					) : new FormControl(
						{ value: '', disabled: true },
						{ validators: Validators.required }
					);
				}
			}
		}
		return this.fb.group({
			steelGrade: new FormControl(this.preSelectedSteelGrade, { validators: Validators.required }),
			thickness: new FormControl('', { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/)
			] }),
			width: new FormControl('', { validators: [
				Validators.required,
				Validators.pattern('^[0-9]*$'),
				this.widthInDplScopeValidator()
			] }),
			maxCoilWeight: new FormControl('', { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
				Validators.max(this.maxCoilWeightMax),
				Validators.min(this.maxCoilWeightMin)
			] }),
			maxSpecificWeight: new FormControl('', { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/)
			] }),
			coil: new FormControl('', { validators: [
				Validators.required,
				Validators.min(1),
				Validators.max(1000),
				Validators.pattern('^[0-9]*$')
			] }),
			noOfQli: new FormControl(PRICE_DEFAULT),
			variableFormGroup: new FormGroup(variableGroup),
			configErrMsg: new FormControl(''),
			price: new FormControl(PRICE_DEFAULT),
			loader: new FormControl('false'),
			errAlertIcon: new FormControl(false),
			qliId: new FormControl(''),
			sqnNumber: new FormControl('')
		});
	}

	getMaxCoilWeightRanges() {
		if (this.millOfferData?.dplconstraintsList) {
			// find DPLScopes where setting inside is matching selected steelgrade, thickness & width
			const maxCoilWeightConstraints = this.millOfferData.dplconstraintsList[0].settingGroups
				.flatMap(item => item.settings)
				.filter(v => v.fieldName.toLowerCase() === 'maxcoilweight');
			if (maxCoilWeightConstraints.length > 0) {
				const maxCoilweightMinValue = maxCoilWeightConstraints
					.reduce((prev, curr) => prev.minValue > curr.minValue
						|| (prev.minValue === curr.minValue && !curr.minValueExcluded) ? curr : prev);
				const maxCoilweightMaxValue = maxCoilWeightConstraints
					.reduce((prev, curr) => prev.maxValue < curr.maxValue
						|| (prev.maxValue === curr.maxValue && !curr.maxValueExcluded) ? curr : prev);
				return [maxCoilweightMinValue.minValue, maxCoilweightMaxValue.maxValue];
			}
		}
		return [];
	}

	isPastOrderHistoryAvailable() {
		const offerRequest: OfferRequest = {
			soldTo: <string> this.form.controls['soldTo'].value,
			productCategory: this.millOfferData?.category,
			productSubCategory: this.millOfferData?.subCategory,
			dealType: this.millOfferData?.dealType,
		};
		this.offerRequestSubsc = this.need4SteelService.isPastOrderHistoryAvailable(offerRequest).subscribe({
			next: result => {
				this.disabled = result;
				this.isLoading = false;
			},
			error: (error: unknown) => {
				console.error(error);
				this.isLoading = false;
			}
		});
	}

	getThicknessHintText(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl>controlArray.controls[index].get('steelGrade');
		if (steelGradeControl.value === '' && steelGradeControl.value === null) {
			return '';
		}
		const { min, max, minExcluded, maxExcluded } = this.refreshThicknessMinMax(index);
		const minSign = minExcluded ? '<' : '≤';
		const maxSign = maxExcluded ? '<' : '≤';
		const fieldName = this.translationService.getTR('need4steel.wizard.stepper.product.thickness');
		if (!min && !max) {
			return '';
		}
		return `${ String(min) } ${ minSign } ${ fieldName } ${ maxSign } ${ String(max) }`;
	}

	getWidthHintText(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl> controlArray.controls[index].get('steelGrade');
		if (steelGradeControl.value === null || steelGradeControl.value === '') {
			return '';
		}
		const thicknessControl = <FormControl> controlArray.controls[index].get('thickness');
		if (thicknessControl.value === null || thicknessControl.value === '') {
			return '';
		}
		const { min, max, minExcluded, maxExcluded } = this.refreshWidthMinMax(index);
		const minSign = minExcluded ? '<' : '≤';
		const maxSign = maxExcluded ? '<' : '≤';
		const fieldName = this.translationService.getTR('need4steel.wizard.stepper.product.width');
		if (!min && !max) {
			return '';
		}
		return `${ String(min) } ${ minSign } ${ fieldName } ${ maxSign } ${ String(max) }`;
	}

	getThicknessList(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const selectedSteelGrade = String((<FormControl>controlArray.controls[index].get('steelGrade')).value);
		const thicknesslist: number[] = [];
		if (this.millOfferData?.dplconstraintsList) {
			// find DPLScopes where setting inside is matching selected steelgrade
			const dplScopes = this.millOfferData.dplconstraintsList
				.filter(value => this.dplScopeHasKeyValue(value, 'steelgrade', selectedSteelGrade));
			const thicknessConstraints = dplScopes
				.flatMap(v => v.settingGroups)
				.flatMap(item => item.settings)
				.filter(v => v.fieldName.toLowerCase() === 'thicknessvalue');
			if (thicknessConstraints.length > 0) {
				for (const thickness of thicknessConstraints) {
					if (!thicknesslist.includes(thickness.minValue)
						&& thickness.minValue === thickness.maxValue) {
						thicknesslist.push(thickness.minValue);
					}
				}
			}
		}
		return thicknesslist.sort((a, b) => a - b);
	}

	getWidthList(index: number): number[] {
		return this.getWidthScopeForRow(index).discreteValues;
	}

	useWidthDropdown(formIndex: number): boolean {
		return this.getWidthScopeForRow(formIndex).mode === 'list';
	}

	getMaxSpecificWeightHintText(index: number) {
		const min = this.getMaxSpecificWeightMin(index);
		const max = this.getMaxSpecificWeightMax(index);
		return this.translationService.getTR(
			'need4steel.dialog.specific.weight.range',
			{ minValue: min ? Math.ceil(min * 100) / 100 : 0,
				maxValue: max ? Math.floor(max * 100) / 100 : 0 }
		);
	}

	refreshWidthMinMax(formIndex: number): NumericRange {
		const scope = this.getWidthScopeForRow(formIndex);
		if (scope.mode === 'none') {
			return { min: 0, max: 0, minExcluded: true, maxExcluded: true };
		}
		return {
			min: scope.min,
			max: scope.max,
			minExcluded: scope.minExcluded,
			maxExcluded: scope.maxExcluded
		};
	}

	getVariableOptions(formIndex: number, variable: Variable): ListValue[] {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const qliId = String((<FormControl | undefined> controlArray.controls[formIndex].get('qliId'))?.value);
		const dplScope = this.millOfferData?.dplconstraintsList?.filter(value => value.qliId === qliId);
		if (dplScope && dplScope.length > 0) {
			const constraint = dplScope[0].settingGroups
				.flatMap(v => v.settings)
				.filter(v => v.fieldName.toLowerCase() === variable.field.toLowerCase());

			if (constraint.length === 1 && constraint[0].attributeValues.length === 1
				&& !this.OPTIONAL_VARIABLE_FIELDS.has(variable.field)) {
				const variableFormControl = <FormControl>controlArray.controls[formIndex]
					.get('variableFormGroup')?.get(variable.field);
				variableFormControl.setValue(constraint[0].attributeValues[0].description);
			}

			if (constraint.length > 0) {
				let values = constraint[0].attributeValues;
				if (this.OPTIONAL_VARIABLE_FIELDS.has(variable.field)) {
					values = values.filter(v => v.code.trim() !== '-');
				}
				values.sort((v1, v2) => v1.description.localeCompare(v2.description));
				return values;
			}
		}
		return [];
	}

	getFieldLabel(fieldLabel: string) {
		return this.productCharacteristicsTranslationService
			.translate(`${ NAMESPACE_A2C_FIELD }${ fieldLabel }`);
	}

	isThicknessDisabled(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl> controlArray.controls[formIndex].get('steelGrade');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		const configErrorMsg = <string[]> (<FormControl> controlArray.controls[formIndex].get('configErrMsg')).value;
		if (thicknessControl.touched && thicknessControl.invalid) {
			controlArray.controls[formIndex].get('noOfQli')?.setValue('');
			if (configErrorMsg.length === 0) {
				controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
			}
		}
		return steelGradeControl.value === '' || steelGradeControl.value === null;
	}

	isWidthDisabled(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const configErrorMsg = <string[]> (<FormControl> controlArray.controls[formIndex].get('configErrMsg')).value;
		if (widthControl.touched && widthControl.invalid && configErrorMsg.length === 0) {
			controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
		}
		return thicknessControl.value === '' || thicknessControl.invalid;
	}

	isMaxCoilWeightDisabled(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const configErrorMsg = <string[]> (<FormControl> controlArray.controls[formIndex].get('configErrMsg')).value;
		if (maxCoilWeightControl.touched && maxCoilWeightControl.invalid && configErrorMsg.length === 0) {
			controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
		}
		this.updateVariablesEnabled(formIndex, !(widthControl.value === '' || widthControl.invalid));
		return widthControl.value === '' || widthControl.invalid;
	}

	isCoilDisabled(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		const configErrorMsg = <string[]> (<FormControl> controlArray.controls[formIndex].get('configErrMsg')).value;
		if ((coilControl.value === '' || coilControl.invalid) && configErrorMsg.length === 0) {
			controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
		}
		if (maxCoilWeightControl.value === '' || maxCoilWeightControl.invalid) {
			return false;
		}
		this.getTotalWeight(formIndex);
		return false;
	}

	getTotalWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		return maxCoilWeightControl.value && coilControl.value && maxCoilWeightControl.valid
			&& coilControl.valid ? (maxCoilWeightControl.value * coilControl.value).toString() : PRICE_DEFAULT;
	}

	getTotalWeightDecimal(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		return maxCoilWeightControl.value && coilControl.value && maxCoilWeightControl.valid
			&& coilControl.valid ? maxCoilWeightControl.value * coilControl.value : 0;
	}

	checkMinMaxCoilWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxcoilweightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		return Boolean(maxcoilweightControl.errors?.['min'] || maxcoilweightControl.errors?.['max']
			|| maxcoilweightControl.errors?.['pattern']);
	}

	checkCoilError(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		return Boolean(coilControl.errors?.['min'] || coilControl.errors?.['max']
			|| coilControl.errors?.['pattern']);
	}

	checkMinMaxThickness(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		const { min, max, minExcluded, maxExcluded } = this.refreshThicknessMinMax(formIndex);
		if (min && max) {
			thicknessControl.setValidators([
				Validators.required,
				Validators.pattern(/^\d*\.?\d{0,2}$/g),
				Validators.min(minExcluded ? min + 0.01 : min),
				Validators.max(maxExcluded ? max - 0.01 : max)
			]);
			thicknessControl.updateValueAndValidity();
		}
		return Boolean(thicknessControl.errors?.['min'] || thicknessControl.errors?.['max']
			|| thicknessControl.errors?.['pattern']);
	}

	checkMinMaxWidth(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		return Boolean(
			widthControl.errors?.['outOfDplScope']
			|| widthControl.errors?.['pattern']
		);
	}

	duplicateProduct(index: number) {
		this.productsCount += 1;
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		const newProductFormGroup = new FormGroup(this.productFormGroup.controls);
		const newControl = <FormArray> newProductFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl> newControl.controls[index].get('steelGrade');
		const thicknessControl = <FormControl> newControl.controls[index].get('thickness');
		const widthControl = <FormControl> newControl.controls[index].get('width');
		const maxCoilWeightControl = <FormControl> newControl.controls[index].get('maxCoilWeight');
		const maxSpecificWeightControl = <FormControl> newControl.controls[index].get('maxSpecificWeight');
		const coilControl = <FormControl> newControl.controls[index].get('coil');
		const noOfQliControl = <FormControl> newControl.controls[index].get('noOfQli');
		const loaderControl = <FormControl> newControl.controls[index].get('loader');
		const errAlertIconControl = <FormControl> newControl.controls[index].get('errAlertIcon');
		const qliIdControl = <FormControl> newControl.controls[index].get('qliId');
		const sqnNumberControl = <FormControl> newControl.controls[index].get('sqnNumber');
		const newVariableGroup: Record<string, AbstractControl> = {};
		const duplicatesimulationResponsedMap = this.millOfferService.simulationResponseList[index];
		const effectivePrice = this.getTotalPrice(index);
		const duplicatesimulationResponsedMapdata: Map<string, ProductDetails> =
			new Map<string, ProductDetails>(duplicatesimulationResponsedMap);
		this.millOfferService.simulationResponseList.push(duplicatesimulationResponsedMapdata);
		if (this.secondRowVariables) {
			for (const varaiblelist of this.secondRowVariables) {
				const { field } = varaiblelist;
				const variablefield = <FormControl> control.controls[index].get('variableFormGroup')?.get(field);
				newVariableGroup[varaiblelist.field] = this.isVariableSpecific(field)
					? new FormControl(
						variablefield.value,
						{ nonNullable: true }
					)
					: this.OPTIONAL_VARIABLE_FIELDS.has(field)
						? new FormControl(variablefield.value)
						: new FormControl(
							variablefield.value,
							{ validators: Validators.required }
						);
			}
		}
		const newFormGroup = this.fb.group({
			steelGrade: new FormControl(steelGradeControl.value, { validators: Validators.required }),
			thickness: new FormControl(thicknessControl.value, {
				validators: [Validators.required, Validators.pattern(/^-?\d*(\.\d{0,2})?$/)]
			}),
			width: new FormControl(widthControl.value, {
				validators: [
					Validators.required,
					Validators.pattern('^[0-9]*$'),
					this.widthInDplScopeValidator()
				]
			}),
			maxCoilWeight: new FormControl(maxCoilWeightControl.value, { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
				Validators.max(this.maxCoilWeightMax),
				Validators.min(this.maxCoilWeightMin)
			] }),
			maxSpecificWeight: new FormControl(maxSpecificWeightControl.value, { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
				Validators.max(this.getMaxSpecificWeightMax(index)),
				Validators.min(this.getMaxSpecificWeightMin(index))
			] }),
			coil: new FormControl(coilControl.value, { validators: [
				Validators.required,
				Validators.min(1),
				Validators.max(1000),
				Validators.pattern('^[0-9]*$')
			] }),
			noOfQli: new FormControl(noOfQliControl.value),
			variableFormGroup: new FormGroup(newVariableGroup),
			configErrMsg: new FormControl(this.getConfigErrorMsg(index)),
			price: new FormControl(effectivePrice),
			loader: new FormControl(loaderControl),
			errAlertIcon: new FormControl(errAlertIconControl),
			qliId: new FormControl(qliIdControl.value),
			sqnNumber: new FormControl(sqnNumberControl.value),
		});
		newFormGroup.markAllAsTouched();
		control.push(newFormGroup);
		if (this.packagingOptions.size > 0) {
			const packagingForm = <FormControl>
				control.controls[this.productsCount - 1].get('variableFormGroup')?.get('packagingCode');
			this.updatePackagingValidators(packagingForm, this.productsCount - 1);
		}

		if (!effectivePrice) {
			this.prepareDataAndCallForSimulateA2Cproduct(control.length - 1);
		}
	}

	async resetProduct(index: number, changeSteelGrade?: boolean) {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		if (!this.userService.user.readOnly) {
			const price = control.controls[index].get('price');
			if (price?.value !== '─' || price.value !== null || price.value !== '') {
				await this.ngZone.runOutsideAngular(async () => {
					await this.sendN4SData(index, 'REMOVE', '', '');
				});
			}
		}
		control.controls[index].get('variableFormGroup')?.reset();
		control.controls[index].get('thickness')?.setValue('');
		control.controls[index].get('width')?.setValue('');
		control.controls[index].get('maxCoilWeight')?.setValue('');
		control.controls[index].get('maxSpecificWeight')?.setValue('');
		control.controls[index].get('noOfQli')?.setValue('');
		control.controls[index].get('configErrMsg')?.setValue('');
		control.controls[index].get('qliId')?.setValue('');
		control.controls[index].get('sqnNumber')?.setValue('');
		control.controls[index].get('price')?.setValue(PRICE_DEFAULT);
		control.controls[index].get('variableFormGroup')?.disable();
		if (this.millOfferService.simulationResponseList.length > 0
			&& this.millOfferService.simulationResponseList[index]) {
			this.millOfferService.simulationResponseList[index].clear();
		}
		if (!changeSteelGrade) {
			control.controls[index].get('steelGrade')?.setValue('');
			control.controls[index].get('coil')?.setValue('');
		}
		control.controls[index].setErrors(null);
		control.controls[index].markAsUntouched();
	}

	updateVariablesEnabled(formIndex: number, enable = true) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const maxSpecificWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		const weightControl = this.getWeightType() === 'maxWeightPerWidthUnitValue'
			? maxSpecificWeightControl : maxCoilWeightControl;
		if (this.secondRowVariables) {
			for (const variable of this.secondRowVariables) {
				const { field } = variable;
				const fieldForm = <FormControl> controlArray.controls[formIndex].get('variableFormGroup')?.get(field);
				if (enable) {
					fieldForm.enable();
				} else {
					fieldForm.disable();
				}
			}
		}
		return weightControl.value === '' || weightControl.value === null || weightControl.invalid;
	}

	ngAfterViewInit() {
		this.changeDetectorRef.detectChanges();
	}

	ngOnDestroy(): void {
		this.eventsSubscription?.unsubscribe();
		this.scrollEventSubscription?.unsubscribe();
		this.exchangeRateSubscription?.unsubscribe();
		this.priceRequestSubscription?.unsubscribe();
		this.a2CSimulationSubscription?.unsubscribe();
		this.coilCalculatorResultSubscription?.unsubscribe();
		this.offerRequestSubsc?.unsubscribe();
		this.orderHistoryImportSub?.unsubscribe();
		this.soldToChangeSubscription.unsubscribe();
		this.endUserChangeSubscription.unsubscribe();
	}

	getThicknessValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		return <string> thicknessControl.value;
	}

	getWidthValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		return <string> widthControl.value;
	}

	getMaxCoilWeightValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		return <string> maxCoilWeightControl.value;
	}

	getMaxSpecWeightValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxSpecWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		return <string> maxSpecWeightControl.value;
	}

	getCoilValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		return <string> coilControl.value;
	}

	getSteelGradeValue(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl> controlArray.controls[formIndex].get('steelGrade');
		return <string> steelGradeControl.value;
	}

	getMaxCoilWeightHintText() {
		const minSign = '≤';
		const maxSign = '≤';
		const fieldName = this.translationService.getTR('need4steel.dialog.coil.weight');
		return `${ String(this.maxCoilWeightMin) } ${ minSign } ${ fieldName } ${ maxSign }
		${ String(this.maxCoilWeightMax) }`;
	}

	getVariableListValue(index: number, field: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const variableFormControl = <FormControl> controlArray.controls[index].get('variableFormGroup')?.get(field);
		return variableFormControl.value ? String(variableFormControl.value) : '';
	}

	checkIfAllfieldsAreSelected(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelGradeControl = <FormControl> controlArray.controls[index].get('steelGrade');
		const thicknessControl = <FormControl> controlArray.controls[index].get('thickness');
		const widthControl = <FormControl> controlArray.controls[index].get('width');
		const coilControl = <FormControl> controlArray.controls[index].get('coil');
		const maxCoilWeightControl = <FormControl> controlArray.controls[index].get('maxCoilWeight');
		const maxSpecificWeightControl = <FormControl> controlArray.controls[index].get('maxSpecificWeight');
		const weightControl = this.getWeightType() === 'maxWeightPerWidthUnitValue'
			? maxSpecificWeightControl : maxCoilWeightControl;

		if (steelGradeControl.valid && thicknessControl.valid && widthControl.valid && coilControl.valid
			&& weightControl.valid) {
			if (this.secondRowVariables !== undefined) {
				for (const variableObj of this.secondRowVariables) {
					const { field } = variableObj;
					const variableField = <FormControl> controlArray.controls[index]
						.get('variableFormGroup')?.get(field);
					if (!this.isVariableSpecific(field)
						&& !this.OPTIONAL_VARIABLE_FIELDS.has(field) && !String(variableField.value)) {
						return false;
					}
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
		return true;
	}

	prepareDataAndCallForSimulateA2Cproduct(index: number) {
		if (this.a2CSimulationSubscriptionArr !== undefined) {
			this.a2CSimulationSubscriptionArr[index]?.unsubscribe();
		}
		if (this.priceRequestSubscriptionArr !== undefined) {
			this.priceRequestSubscriptionArr[index]?.unsubscribe();
		}
		const flagForSimulation = this.checkIfAllfieldsAreSelected(index);
		const flagHeaderFieldsCheck = this.checkAllHeaderFieldValid();
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const noOfQli = Number(<FormControl>controlArray.controls[index].get('noOfQli')?.value);
		if (!this.checkLogisticsConstraints(index) && flagForSimulation && flagHeaderFieldsCheck && noOfQli === 1) {
			const templateDescription = <TemplateDescription>{};
			if (this.millOfferData !== undefined) {
				if (this.maxSpecCoilWeightOptionAvailable) {
					if (this.getWeightType() === 'maxWeightPerWidthUnitValue') {
						this.calculateMaxCoilWeightDecimal(index);
					} else {
						this.calculateMaxSpecWeightDecimal(index);
					}
				}
				if (this.millOfferData.templateNumber !== undefined) {
					templateDescription.templateNumber = this.millOfferData.templateNumber;
				}
				let productConfigObj = <ProductConfiguration>{};
				controlArray.controls[index].setErrors(null);
				controlArray.controls[index].markAsUntouched();
				if (this.secondRowVariables !== undefined) {
					for (const key of this.secondRowVariables) {
						const keyField = key.field[0].toLowerCase() + key.field.slice(1);
						const fieldCodeValue = key.templateProperty.type === 'array' ? [
							{
								[keyField]: this.getFieldCode(index, key.field)
							}
						] : this.getFieldCode(index, key.field);
						productConfigObj =
						this.need4steelHelperService.setProperty(productConfigObj, keyField, fieldCodeValue);
					}
				}
				const steelGradeValue = this.getSteelGradeCode(index);
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'steelGrade', steelGradeValue);
				const thicknessValue = Number(<FormControl>controlArray.controls[index].get('thickness')?.value);
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'thicknessValue', thicknessValue);
				const widthValue = Number(<FormControl>controlArray.controls[index].get('width')?.value);
				productConfigObj = this.need4steelHelperService.setProperty(productConfigObj, 'widthValue', widthValue);
				const finishingLine = [{ finishingLine: this.millSiteCode }];
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'finishingLine', finishingLine);
				if (this.getWeightType() === 'maxWeightPerWidthUnitValue') {
					const maxSpecWeight = Number(<FormControl>controlArray
						.controls[index].get('maxSpecificWeight')?.value);
					productConfigObj =
					this.need4steelHelperService.setProperty(
						productConfigObj,
						'maxWeightPerWidthUnitValue',
						maxSpecWeight
					);
				} else {
					const maxCoilWeightValue = Number(<FormControl>controlArray
						.controls[index].get('maxCoilWeight')?.value);
					productConfigObj =
					this.need4steelHelperService.setProperty(productConfigObj, 'maxNetWeightValue', maxCoilWeightValue);
				}
				const shipToParty = String(this.form.getFormShipTo().value).padStart(10, '0');
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'shipToParty', shipToParty);
				const endUser = String(this.form.getFormEndUser().value).padStart(10, '0');
				productConfigObj = this.need4steelHelperService.setProperty(productConfigObj, 'endUser', endUser);
				const soldToParty = String(this.form.getFormSoldTo().value).padStart(10, '0');
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'soldToParty', soldToParty);
				const templateNbr = this.millOfferData.templateNumber;
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'templateNumber', templateNbr);
				const sbCategory = this.millOfferData.subCategory;
				productConfigObj =
				this.need4steelHelperService.setProperty(productConfigObj, 'subCategory', sbCategory);
				const loaderControl = <FormControl>controlArray.controls[index].get('loader');
				const isPriceControl = <FormControl>controlArray.controls[index].get('price');
				const configErrMsgControl = <FormControl>controlArray.controls[index].get('configErrMsg');

				const qliIdCtrl = <FormControl> controlArray.controls[index].get('qliId');
				const qliIdVal = String(qliIdCtrl.value);
				const isShipmentEnabled = this.need4steelWizardService
					.isShipmentSelectionEnabled(this.millOfferData.millSite);
				const tmode = isShipmentEnabled
					? <string> this.form.getFormTmode().value || DEFAULT_TRANSPORT_MODE
					: DEFAULT_TRANSPORT_MODE;
				const incoterms = isShipmentEnabled
					? <string> this.form.getFormIncoterm().value || DEFAULT_INCOTERM
					: DEFAULT_INCOTERM;
				const millOrder = this.createPriceRequestObject(index, controlArray, tmode, incoterms);
				const requestSimuPriceNumber = this.generateRandomSimuPriceNumber();
				let priceResponse: MillOrderPriceResponse;
				let simulationResponded = false;
				let simulationHasError = false;
				let priceResponded = false;
				let priceHasError = false;
				if (millOrder !== undefined) {
					const a2CSimulationSubscriptionLocal = this.simulateA2Cproduct(productConfigObj, index)
						.subscribe({
							next: async simulationResponselocal => {
								if (simulationResponselocal === undefined) {
									loaderControl.setValue('false');
									this.changeDetectorRef.detectChanges();
									simulationHasError = true;
									return;
								}
								const configurationErrors = simulationResponselocal.errors
									? [...simulationResponselocal.errors] : [];
								if (configurationErrors.length === 0 && this.millOfferData !== undefined) {
									if (!this.userService.user.readOnly) {
										await this.sendN4SData(index, 'SIMU', 'YES', requestSimuPriceNumber);
									}
									simulationResponded = true;
									this.createSimulationResponseDataMap(simulationResponselocal, index);
									if (priceResponded) {
										this.processEffectivePrice(priceResponse, index);
									} else if (priceHasError) {
										configErrMsgControl.setValue('price error');
										isPriceControl.setValue('');
										loaderControl.setValue('false');
										this.changeDetectorRef.detectChanges();
									}
								} else {
									if (!this.userService.user.readOnly) {
										await this.sendN4SData(index, 'SIMU', 'NO', requestSimuPriceNumber);
									}
									configErrMsgControl.setValue(configurationErrors);
									if (configErrMsgControl.value) {
										loaderControl.setValue('false');
										this.changeDetectorRef.detectChanges();
									}
									simulationHasError = true;
								}
							},
							error: () => {
								loaderControl.setValue('false');
								this.changeDetectorRef.detectChanges();
							}
						});
					if (this.a2CSimulationSubscriptionArr !== undefined) {
						this.a2CSimulationSubscriptionArr.splice(index, 1, a2CSimulationSubscriptionLocal);
					}
					const priceRequestSubscriptionLocal = this.need4SteelService.getPriceForOfferLine(
						this.millOfferData.id,
						qliIdVal,
						millOrder,
						requestSimuPriceNumber
					)
						.subscribe({
							next: priceResponseLocal => {
								priceResponse = priceResponseLocal;
								priceResponded = true;
								if (simulationResponded && !simulationHasError) {
									this.processEffectivePrice(priceResponse, index);
								}
							},
							error: (err: unknown) => {
								priceHasError = true;
								if (simulationResponded && !simulationHasError) {
									console.error('unable to load mill price', err);
									configErrMsgControl.setValue('price error');
									isPriceControl.setValue('');
									loaderControl.setValue('false');
									this.changeDetectorRef.detectChanges();
								}
							}
						});
					if (this.priceRequestSubscriptionArr !== undefined) {
						this.priceRequestSubscriptionArr.splice(index, 1, priceRequestSubscriptionLocal);
					}
				}
			}
		}
	}

	getOutsideDiameter(insideDiameter: string, index: number) {
		const coilCalculator = new CoilCalculator();
		this.coilCalculatorResultSubscription?.unsubscribe();
		coilCalculator.nominalThickness = <number><unknown> this.getThicknessValue(index);
		coilCalculator.innerDiameter = this.extractNumber(insideDiameter);
		coilCalculator.width = <number><unknown> this.getWidthValue(index);
		coilCalculator.calculationType = HOT_OR_COLD_ROLLED;
		coilCalculator.additionalDataChoice = 'coilWeight';
		coilCalculator.additionalData = <number> <unknown> this.getMaxCoilWeightValue(index);
		return this.coilCalculatorService.coilCalculatorResult(coilCalculator);
	}

	extractNumber(input: string): number {
		const matches = /\d+/.exec(input);
		if (matches && matches.length > 0) {
			return Number.parseInt(matches[0], 10);
		}
		return 0;
	}

	createSimulationResponseDataMap(simulationResponselocal: UfoProductSimulationResponse, index: number) {
		const simulationResponseMap = this.millOfferService.simulationResponseList[index]
			?? new Map<string, ProductDetails>();
		simulationResponseMap.set('insideDiameter', {
			label: this.translationService.getTR('product.title.section.insideDiameter'),
			value: simulationResponselocal.configuration?.insideDiameterCode,
			isNumeric: false,
			fontType: 'normal'
		});
		let maxOutsideDiameter;
		const insideDiameter = simulationResponselocal.configuration?.insideDiameterCode;
		if (insideDiameter) {
			this.coilCalculatorResultSubscription = this.getOutsideDiameter(insideDiameter, index).subscribe(
				{ next: (data: CoilCalculatorResult) => {
					maxOutsideDiameter = data.coilOuterDiameter;
					simulationResponseMap.set('outsideDiameter', {
						label: this.translationService.getTR('need4steel-product-details.max-outside-Diameter'),
						value: maxOutsideDiameter,
						isNumeric: true,
						fontType: 'normal'
					});
				},
				error: (error: unknown) => {
					console.error(error);
				} }
			);
		}
		simulationResponseMap.set('outsideDiameter', {
			label: this.translationService.getTR('need4steel-product-details.max-outside-Diameter'),
			value: maxOutsideDiameter,
			isNumeric: true,
			fontType: 'normal'
		});
		simulationResponseMap.set('minCoilWeight', {
			label: this.translationService.getTR('need4steel-product-details.min-coil-weight'),
			value: simulationResponselocal.configuration?.minNetWeightValue,
			isNumeric: true,
			fontType: 'normal'
		});

		if (!(this.millOfferData?.category === 'HR' && this.millOfferData.subCategory === 'BL')) {
			simulationResponseMap.set('surfacAspect', {
				label: this.translationService.getTR('eorder.product.surfaceaspect'),
				value: simulationResponselocal.configuration?.surfaceAspect,
				isNumeric: false,
				fontType: 'normal'
			});
		}
		if (this.millOfferData?.category === 'EG' && this.millOfferData.subCategory === 'ZVI') {
			simulationResponseMap.set('metalliCoating', {
				label:	this.translationService.getTR('eorder.product.metalliccoating'),
				value: simulationResponselocal.configuration?.metallicCoating,
				isNumeric: false,
				fontType: 'normal'
			});
		}
		if ((this.millOfferData?.category === 'EG' && this.millOfferData.subCategory === 'ZVI')
			|| (this.millOfferData?.category === 'HD' && this.millOfferData.subCategory === 'ZM')
			|| (this.millOfferData?.category === 'HD' && this.millOfferData.subCategory === 'Z')) {
			simulationResponseMap.set('chemicalTreatment', {
				label: this.translationService.getTR('need4steel-product-details.chemical-treatment'),
				value:	simulationResponselocal.configuration?.chemicalTreatment,
				isNumeric: false,
				fontType: 'normal'
			});
		}
		if (!(this.millOfferData?.category === 'HR' && this.millOfferData.subCategory === 'BL')) {
			simulationResponseMap.set('pickled', {
				label:	`${ this.translationService.getTR('datacenter.pickled') }
		${ this.translationService.getTR('defect.CDCUS00E') }`,
				value:	simulationResponselocal.configuration?.pickledWelds,
				isNumeric: false,
				fontType: 'normal'
			});
		}

		if (!((this.millOfferData?.category === 'HR' && this.millOfferData.subCategory === 'BL')
			|| (this.millOfferData?.category === 'OC' && this.millOfferData.subCategory === 'OZ'))) {
			simulationResponseMap.set('unrolledWelds', {
				label:	this.translationService.getTR('need4steel-product-details.unrolledWelds'),
				value:	simulationResponselocal.configuration?.unrolledWelds,
				isNumeric: false,
				fontType: 'normal'
			});
		}
		if (!this.millOfferService.simulationResponseList[index]) {
			this.millOfferService.simulationResponseList.splice(index, 1, simulationResponseMap);
		}
	}

	processEffectivePrice(priceResponse: MillOrderPriceResponse, index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const loaderControl = <FormControl>controlArray.controls[index].get('loader');
		const isPriceControl = <FormControl>controlArray.controls[index].get('price');
		const configErrMsgControl = <FormControl>controlArray.controls[index].get('configErrMsg');

		isPriceControl.setValue('');
		loaderControl.setValue('false');
		let priceErrorMsg = 'Price information could not be found';
		if (!priceResponse.isError) {
			const priceResponseArr = priceResponse['priceList'];
			const effectivePrice = priceResponseArr && priceResponseArr.length > 0
				&& priceResponseArr[0].ok
				? priceResponseArr[0].effectivePrice : priceResponse.effectivePrice;
			if (effectivePrice) {
				priceErrorMsg = '';
				isPriceControl.setValue(effectivePrice);
				this.millPrice = <number>isPriceControl.value;
			}
		} else {
			priceErrorMsg = priceResponse['message'] || priceErrorMsg;
		}
		configErrMsgControl.setValue(priceErrorMsg);
		this.changeDetectorRef.detectChanges();
	}

	getTotalPrice(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const effectivePrice = <FormControl>controlArray.controls[formIndex].get('price')?.value;
		if	(Number.isNaN(Number(effectivePrice)))	{
			return effectivePrice;
		}
		return formatNumber(<number><unknown>effectivePrice, 'amount');
	}

	getSteelGradeCode(formIndex: number) {
		const steelGrade = this.getSteelGradeValue(formIndex);
		if (this.millOfferData?.dplconstraintsList) {
			const steelGrades = this.millOfferData.dplconstraintsList
				.flatMap(item => item.settingGroups)
				.flatMap(v => v.settings)
				.filter(v => v.fieldName.toLowerCase() === 'steelgrade')
				.flatMap(v => v.attributeValues)
				.filter(v => v.description === steelGrade)
				.map(v => v.code)
				.filter((value, index, self) => self.indexOf(value) === index)
				.sort((a, b) => a.localeCompare(b));
			return steelGrades.length > 0 ? steelGrades[0] : '';
		}
		return '';
	}

	getFieldCode(formIndex: number, field: string) {
		const variablefieldValue = this.getVariableListValue(formIndex, field);
		if (this.isVariableSpecific(field)) {
			return variablefieldValue;
		}
		if (this.millOfferData?.dplconstraintsList) {
			const qliId = String((<FormArray> this.productFormGroup.get('productSpecifications'))
				.controls[formIndex].get('qliId')?.value ?? '');
			const variableOptions = this.millOfferData.dplconstraintsList
				.filter(scope => !qliId || scope.qliId === qliId)
				.flatMap(item => item.settingGroups)
				.flatMap(v => v.settings)
				.filter(v => v.fieldName.toLowerCase() === field.toLowerCase())
				.flatMap(v => v.attributeValues)
				.filter(v => v.description === variablefieldValue)
				.map(v => v.code)
				.filter((value, index, self) => self.indexOf(value) === index)
				.sort((a, b) => a.localeCompare(b));
			return variableOptions.length > 0 ? variableOptions[0] : '';
		}
		return '';
	}

	isVariableSpecific(field: string): boolean {
		return isVariableSpecificField(field);
	}

	getConfigErrorMsg(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const configErrMsgControl = <FormControl> controlArray.controls[formIndex].get('configErrMsg');
		return <string> configErrMsgControl.value;
	}

	getPrice(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const priceControl = <FormControl> controlArray.controls[formIndex].get('price');
		return <string> priceControl.value;
	}

	getLoader(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const loaderControl = <FormControl> controlArray.controls[formIndex].get('loader');
		return <string> loaderControl.value;
	}

	onThicknessChangeForTextField(formIndex: number, event: Event) {
		const target = <HTMLInputElement> event.target;
		this.onThicknessChange(formIndex, target.value);
	}

	onThicknessChange(formIndex: number, value: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const { min, max } = this.refreshWidthMinMax(formIndex);
		if ((min && max && (widthControl.value < min || widthControl.value > max)) || widthControl.invalid) {
			controlArray.controls[formIndex].get('width')?.setValue('');
			controlArray.controls[formIndex].get('configErrMsg')?.setValue('');
			controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
		}
		if	(widthControl.valid && thicknessControl.valid)	{
			this.fetchQliDetailsFromDplScope(formIndex);
		}
		if (value && thicknessControl.valid) {
			this.prepareDataAndCallForSimulateA2Cproduct(formIndex);
		}
	}

	onWidthChangeForTextField(formIndex: number, event: Event) {
		const target = <HTMLInputElement> event.target;
		this.onWidthChange(formIndex, target.value);
	}

	onWidthChange(formIndex: number, value: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		this.fetchQliDetailsFromDplScope(formIndex);
		if (value && widthControl.valid)	{
			this.prepareDataAndCallForSimulateA2Cproduct(formIndex);
		}
	}

	fetchQliDetailsFromDplScope(formIndex: number)	{
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelgrade = String(
			(<FormControl | undefined> controlArray.controls[formIndex].get('steelGrade'))?.value
		);
		const thickness = Number(
			(<FormControl | undefined> controlArray.controls[formIndex].get('thickness'))?.value
		);
		const width = Number(
			(<FormControl | undefined> controlArray.controls[formIndex].get('width'))?.value
		);
		// find DPLScopes where all main settings are matching (steelgrade, thickness and width)
		if (this.millOfferData?.dplconstraintsList) {
			const dplScopesFullmatchingProduct = this.millOfferData.dplconstraintsList
				.filter(v => this.dplScopeHasKeyValue(v, 'steelgrade', steelgrade))
				.filter(v => this.dplScopeHasThicknessWidthPair(v, thickness, width));
			const noOfQli = dplScopesFullmatchingProduct.length;
			controlArray.controls[formIndex].get('noOfQli')?.setValue(noOfQli);
			if (noOfQli === 1) {
				const [dplscope] = dplScopesFullmatchingProduct;
				controlArray.controls[formIndex]?.get('qliId')?.setValue(dplscope.qliId);
				controlArray.controls[formIndex]?.get('sqnNumber')?.setValue(dplscope.sqn);
			}
		}
	}

	onMaxCoilWeightChange(formIndex: number, event: Event) {
		const target = <HTMLInputElement> event.target;
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		if (!(target.value && maxCoilWeightControl.valid)) {
			const maxSpecificWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
			maxSpecificWeightControl.setValue('');
		}
		this.prepareDataAndCallForSimulateA2Cproduct(formIndex);
	}

	onCoilNumberChange(formIndex: number, event: Event) {
		const target = <HTMLInputElement> event.target;
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const coilControl = <FormControl> controlArray.controls[formIndex].get('coil');
		if (target.value && coilControl.valid) {
			this.prepareDataAndCallForSimulateA2Cproduct(formIndex);
		}
	}

	onWeightTypeChange() {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		for (let i = 0; i < control.length; i++) {
			control.controls[i].get('maxCoilWeight')?.setValue('');
			control.controls[i].get('maxSpecificWeight')?.setValue('');
			control.controls[i].get('price')?.setValue(PRICE_DEFAULT);
			control.controls[i].markAsUntouched();
		}
	}

	checkAllHeaderFieldValid() {
		return this.form.getFormShipTo().valid && this.form.getFormSoldTo().valid && this.form.getFormEndUser().valid;
	}

	generateRandomSimuPriceNumber() {
		return uuidv4();
	}

	createPriceRequestObject(
		index: number,
		controlArray: FormArray,
		transportMode: string,
		incoterms: string
	): MillOrder | undefined {
		if (this.millOfferData !== undefined) {
			const steelGradeValue = this.getSteelGradeCode(index);
			const thicknessValue = Number(this.getThicknessValue(index));
			const widthValue = Number(<FormControl> controlArray.controls[index].get('width')?.value);
			const maxCoilWeightValue = Number(<FormControl> controlArray
				.controls[index].get('maxCoilWeight')?.value);
			const quantity = (Number(<FormControl> controlArray
				.controls[index].get('coil')?.value) * maxCoilWeightValue).toFixed(2);
			const noOfcoils = Number(<FormControl>controlArray.controls[index].get('coil')?.value);
			const qliIdControl = <FormControl> controlArray.controls[index].get('qliId');
			const sqnControl = <FormControl> controlArray.controls[index].get('sqnNumber');
			const maxSpecWeight = Number(<FormControl> controlArray.controls[index].get('maxSpecificWeight')?.value);

			const productCongiguration: Record <string, string> = {
				steelgrade: steelGradeValue,
				category: this.millOfferData.category,
				subcategory: this.millOfferData.subCategory,
				form: this.millOfferData.form,
				thicknessvalue: String(thicknessValue),
				widthvalue: String(widthValue),
				transportmode: transportMode || DEFAULT_TRANSPORT_MODE,
				quantity: String(quantity),
				additionaltest: '',
				finishingLine: String(this.millOfferData.millSiteCode),
				totalweight: this.getTotalWeight(index)
			};
			if (this.getWeightType() === 'maxWeightPerWidthUnitValue') {
				productCongiguration['maxWeightPerWidthUnitValue'] = maxSpecWeight > 0 ? String(maxSpecWeight) : '';
			} else {
				productCongiguration['maxnetweightvalue'] = String(maxCoilWeightValue);
			}
			const eventProductList: N4sEventsProductData[] = [];
			const variableFormControl = <FormControl>controlArray.controls[index].get('variableFormGroup');
			const variableGroup = <FormControl>variableFormControl.value;
			const varFieldKeys = Object.keys(variableGroup);
			for (const field of varFieldKeys) {
				if (!this.isVariableSpecific(field)) {
					const variableCode = this.getFieldCode(index, field);
					const fieldName = field;
					const eventsProductData: N4sEventsProductData = {
						characName: fieldName,
						characValueText: variableCode
					};
					eventProductList.push(eventsProductData);
				}
			}
			const productList = [];
			const product = {
				qliId: String(qliIdControl.value),
				coils: noOfcoils,
				sqn: String(sqnControl.value),
				itemNumber: String(index + 1).padStart(3, '0'),
				need4steelProductDataList: eventProductList,
				productCharacteristics: productCongiguration,
			};
			productList.push(product);
			if (this.secondRowVariables !== undefined) {
				for (const key of this.secondRowVariables) {
					if (!this.isVariableSpecific(key.field)) {
						const field = String(this.getFieldCode(index, key.field));
						productCongiguration[key.field.toLowerCase()] = field;
					}
				}
			}
			return {
				offerRfq: this.millOfferData.rfqNumber || '',
				deliveryWeek: this.millOfferData.deliveryWeek,
				deliveryYear: this.millOfferData.deliveryYear,
				soldTo: String(this.form.getFormSoldTo().value).padStart(10, '0'),
				shipTo: String(this.form.getFormShipTo().value).padStart(10, '0'),
				endUser: String(this.form.getFormEndUser().value).padStart(10, '0'),
				idd: this.millOfferData.idd,
				millSite: this.millOfferData.millSite || '',
				transportMode: transportMode || DEFAULT_TRANSPORT_MODE,
				incoterms: incoterms || DEFAULT_INCOTERM,
				isPriceRequest: true,
				products: productList,
				dealType: this.millOfferData.dealType || '',
				codeUnitRef: this.millOfferService.boc.referenceCommercialUnit?.codeUnit || '',
				codeSubUnitRef: this.millOfferService.boc.referenceCommercialSubUnit?.codeSubUnit || '',
				codeSubSubUnitRef: this.millOfferService.boc.referenceCommercialSubSubUnit?.codeSubSubUnit || '',
			};
		}
		return undefined;
	}

	getWeightType() {
		return <string> this.form.getFormWeightType().value;
	}

	getMaxSpecificWeightMax(index: number) {
		const width = this.getWidthValue(index);
		return this.getMaxSpecificWeightMaxByWidth(width);
	}

	getMaxSpecificWeightMin(index: number) {
		const width = this.getWidthValue(index);
		return this.getMaxSpecificWeightMinByWidth(width);
	}

	getMaxSpecificWeightMaxByWidth(width: number | string) {
		if (width) {
			return Math.trunc(((this.maxCoilWeightMax / Number(width)) * 1000) * 100) / 100;
		}
		return 0;
	}

	getMaxSpecificWeightMinByWidth(width: number | string) {
		if (width) {
			return Math.trunc(((this.maxCoilWeightMin / Number(width)) * 1000) * 100) / 100;
		}
		return 0;
	}

	isMaxSpecWeightDisabled(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const maxSpecWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		const configErrorMsg = <string[]> (<FormControl> controlArray.controls[formIndex].get('configErrMsg')).value;
		if (maxSpecWeightControl.touched && maxSpecWeightControl.invalid && configErrorMsg.length === 0) {
			controlArray.controls[formIndex].get('price')?.setValue(PRICE_DEFAULT);
		}
		this.updateVariablesEnabled(formIndex, !(widthControl.value === '' || widthControl.invalid));
		return widthControl.value === '' || widthControl.invalid;
	}

	checkMinMaxSpecificWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxSpecWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		const min = this.getMaxSpecificWeightMin(formIndex);
		const max = this.getMaxSpecificWeightMax(formIndex);
		if (min && max) {
			maxSpecWeightControl.setValidators([
				Validators.required,
				Validators.pattern(/^\d*\.?\d{0,2}$/g),
				Validators.min(min),
				Validators.max(max)
			]);
			maxSpecWeightControl.updateValueAndValidity();
		}
		return Boolean(maxSpecWeightControl.touched && (maxSpecWeightControl.errors?.['min']
			|| maxSpecWeightControl.errors?.['max'] || maxSpecWeightControl.errors?.['pattern']));
	}

	onMaxSpecificWeightChange(formIndex: number, event: Event) {
		const target = <HTMLInputElement> event.target;
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxSpecificWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		if (!(target.value && maxSpecificWeightControl.valid)) {
			const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
			maxCoilWeightControl.setValue('');
		}
		this.prepareDataAndCallForSimulateA2Cproduct(formIndex);
	}

	calculateMaxSpecWeightDecimal(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const maxSpecificWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		const maxSpecWeight = maxCoilWeightControl.value && widthControl.value && maxCoilWeightControl.valid
			&& widthControl.valid ? (maxCoilWeightControl.value / widthControl.value) * 1000 : 0;
		maxSpecificWeightControl.setValue(Math.round(maxSpecWeight * 100) / 100);
		return maxSpecWeight;
	}

	calculateMaxCoilWeightDecimal(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const maxSpecWeightControl = <FormControl> controlArray.controls[formIndex].get('maxSpecificWeight');
		const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
		const maxCoilWeightControl = <FormControl> controlArray.controls[formIndex].get('maxCoilWeight');
		const maxCoilWeight = maxSpecWeightControl.value && widthControl.value && maxSpecWeightControl.valid
			&& widthControl.valid ? (maxSpecWeightControl.value * widthControl.value) / 1000 : 0;
		maxCoilWeightControl.setValue(Math.round(maxCoilWeight * 100) / 100);
		return maxCoilWeight;
	}

	getControl(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		return <FormControl>controlArray.controls[formIndex].get(controlName);
	}

	getToolTipDescription(index: number) {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		const price = control.controls[index].get('price');
		return (price && price.value === '─') || (price && price.value === null) || (price && price.value === '')
			? this.translationService.getTR('need4steel-product-details-tooltip.no-price-msg')
			: this.translationService.getTR('need4steel-product-details-tooltip.price-msg');
	}

	getDimensionValue(index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl>controlArray.controls[index].get('thickness');
		const widthControl = <FormControl>controlArray.controls[index].get('width');
		return formatDimension(
			<string> thicknessControl.value,
			<string> widthControl.value
		);
	}

	getKeyLabel(key: string) {
		return this.translationService.getTR(key);
	}

	viewProductDetails(index: number) {
		const productDetails: Map<string, ProductDetails> = new Map<string, ProductDetails>();
		productDetails.set('steelGrade', {
			label:	this.getKeyLabel('need4steel.wizard.stepper.product.steelgrade'),
			value: this.getSteelGradeValue(index),
			isNumeric: false,
			fontType: 'Bold'
		});
		productDetails.set('dimension', {
			label: this.getKeyLabel('eoffer.table.header.dimension'),
			value: this.getDimensionValue(index),
			isNumeric: false,
			fontType: 'Bold'
		});
		const coilWeightFontType = this.getWeightType() === 'maxNetWeightValue' ? 'Bold' : 'normal';
		productDetails.set('coilweight', {
			label: this.getKeyLabel('need4steel.product.details.product.coilweight'),
			value: this.getMaxCoilWeightValue(index),
			isNumeric: false,
			fontType: coilWeightFontType
		});
		if (this.maxSpecCoilWeightOptionAvailable) {
			const maxSpecCoilWeightFontType = this.getWeightType() === 'maxWeightPerWidthUnitValue' ? 'Bold' : 'normal';
			productDetails.set('specificWeight', {
				label:	this.getKeyLabel('need4steel.product.details.specific.weight'),
				value:	this.getMaxSpecWeightValue(index),
				isNumeric: true,
				fontType: maxSpecCoilWeightFontType
			});
		}
		productDetails.set('coil', {
			label: this.getKeyLabel('need4steel.wizard.stepper.product.coil'),
			value:	this.getCoilValue(index),
			isNumeric: false,
			fontType: 'Bold'
		});
		productDetails.set('totalWeight', {
			label: this.getKeyLabel('need4steel.wizard.stepper.product.total.weight'),
			value: this.getTotalWeight(index),
			isNumeric: true,
			fontType: 'Bold'

		});
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const variableFormControl = <FormControl>controlArray.controls[index].get('variableFormGroup');
		const variableGroup = <FormControl>variableFormControl.value;
		const varFieldKeys = Object.keys(variableGroup);
		for (const field of varFieldKeys) {
			if (!this.isVariableSpecific(field)) {
				const fieldValue = this.getVariableListValue(index, field);
				productDetails.set(field, {
					label: this.getFieldLabel(field),
					value: fieldValue,
					isNumeric: false,
					fontType: 'Bold'

				});
			}
		}
		for (const [key, value] of this.millOfferService.simulationResponseList[index]) {
			productDetails.set(key, value);
		}
		this.dialog.open(DialogProductDetailsComponent, {
			data: {
				productDetails,
				totalPrice: <string> this.getTotalPrice(index),
			}
		});
	}

	viewOrderedHistory() {
		const dialogRef = this.dialog.open(DialogNeed4SteelOrderHistoryComponent, {
			data: {
				offerRequest: this.requestObject,
			},
			width: '1080px',
		});
		this.orderHistoryImportSub = dialogRef.afterClosed().subscribe(historyData => {
			if (typeof historyData === 'object') {
				const orderHistoryList = <OrderHistory[]> historyData;
				if (orderHistoryList.length > 0) {
					const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
					let index = 0;
					while (index < control.controls.length) {
						const steelGradeControl = <FormControl> control.controls[index].get('steelGrade');
						if (!steelGradeControl.valid) {
							control.controls.splice(index, 1); // removing empty item
							this.productsCount -= 1;
						} else {
							index++;
						}
					}
					const addEmptyRow = control.controls.length === 0;
					for (const orderHistory of orderHistoryList) {
						this.updateHistoryData(orderHistory);
						this.productsCount += 1;
						this.millOfferService.simulationResponseList.push(new Map<string, ProductDetails>());
						this.fetchQliDetailsFromDplScope(this.productsCount - 1);
					}
					if (addEmptyRow) {
						this.productsCount += 1;
						control.push(this.initProductResult());
						this.millOfferService.simulationResponseList.push(new Map<string, ProductDetails>());
					}
				}
			}
		});
	}

	private resetPricesForEndUserChange() {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		for (const [index, control] of controlArray.controls.entries()) {
			control.get('price')?.setValue(PRICE_DEFAULT);
			this.prepareDataAndCallForSimulateA2Cproduct(index);
		}
	}

	private loadExchangeRateIfNeeded() {
		if (!this.need4steelWizardService.shouldDisplayExchangeRate()) {
			return;
		}
		this.exchangeRateSubscription = this.need4steelWizardService.loadExchangeRates().subscribe({
			next: () => {
				this.changeDetectorRef.detectChanges();
			},
			error: (err: unknown) => {
				console.error('error loading exchange rate', err);
				this.changeDetectorRef.detectChanges();
			}
		});
	}

	private updateHistoryData(orderHistory: OrderHistory) {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		const variableGroup: Record<string, AbstractControl> = {};
		if (this.secondRowVariables) {
			for (const variablelist of this.secondRowVariables) {
				let variableValue = '';
				if (orderHistory[variablelist.field]) {
					variableValue = (<CodeValue> orderHistory[variablelist.field]).value;
				}
				variableGroup[variablelist.field] = new FormControl(
					{ value: variableValue, disabled: true },
					{ validators: Validators.required }
				);
			}
		}
		let maxSpecWeight = 0;
		if (this.maxSpecCoilWeightOptionAvailable && this.getWeightType() === 'maxWeightPerWidthUnitValue') {
			maxSpecWeight = Math.round(orderHistory.maxNetWeightValue && orderHistory.widthValue
				? (orderHistory.maxNetWeightValue / orderHistory.widthValue) * 1000 : 0);
		}
		const newFormGroup = this.fb.group({
			steelGrade: new FormControl(orderHistory.steelGrade.value, { validators: Validators.required }),
			thickness: new FormControl(orderHistory.thicknessValue, {
				validators: [Validators.required, Validators.pattern(/^-?\d*(\.\d{0,2})?$/)]
			}),
			width: new FormControl(orderHistory.widthValue, {
				validators: [Validators.required, Validators.pattern('^[0-9]*$')]
			}),
			maxCoilWeight: new FormControl(orderHistory.maxNetWeightValue, { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
				Validators.max(this.maxCoilWeightMax),
				Validators.min(this.maxCoilWeightMin)
			] }),
			maxSpecificWeight: new FormControl(maxSpecWeight > 0 ? maxSpecWeight : '', { validators: [
				Validators.required,
				Validators.pattern(/^-?\d*(\.\d{0,2})?$/),
				Validators.max(this.getMaxSpecificWeightMaxByWidth(orderHistory.widthValue)),
				Validators.min(this.getMaxSpecificWeightMinByWidth(orderHistory.widthValue))
			] }),
			coil: new FormControl('', { validators: [
				Validators.required,
				Validators.min(1),
				Validators.max(1000),
				Validators.pattern('^[0-9]*$')
			] }),
			noOfQli: new FormControl(PRICE_DEFAULT),
			variableFormGroup: new FormGroup(variableGroup),
			configErrMsg: new FormControl(''),
			price: new FormControl(PRICE_DEFAULT),
			loader: new FormControl('false'),
			errAlertIcon: new FormControl(false),
			qliId: new FormControl(''),
			sqnNumber: new FormControl('')
		});
		control.push(newFormGroup);
	}

	private simulateA2Cproduct(configuration: ProductConfiguration | FieldValueObject, index: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const priceControl = <FormControl> controlArray.controls[index].get('price');
		priceControl.setValue('');
		const configErrMsgControl = <FormControl> controlArray.controls[index].get('configErrMsg');
		configErrMsgControl.setValue('');
		const loaderControl = <FormControl> controlArray.controls[index].get('loader');
		loaderControl.setValue('true');
		return this.need4SteelService
			.simulateA2CProduct(configuration, 'INLINE')
			.pipe(
				catchError((err: unknown) => {
					console.error('unable to simulate', err);
					if (err instanceof HttpErrorResponse) {
						if (err.status === 0) {
							configErrMsgControl.setValue(
								[this.translationService.getTR('need4steel.wizard.product.price.calculate.offline')]
							);
						} else {
							configErrMsgControl.setValue(
								[this.translationService.getTR('need4steel.offer.simulation.error.message')]
							);
						}
					}
					return of(undefined);
				})
			);
	}

	private dplScopeHasKeyValue(dplScope: DPLScopeConstraints, key: string, value?: string) {
		if (value === undefined) {
			return true;
		}
		const settingsContainingValue = dplScope.settingGroups
			.flatMap(item => item.settings)
			.filter(v => v.fieldName.toLowerCase() === key.toLowerCase())
			.flatMap(v => v.attributeValues)
			.filter(v => v.description === value);
		return settingsContainingValue.length > 0;
	}

	private dplScopeHasKeyNumericValue(dplScope: DPLScopeConstraints, key: string, value?: number) {
		if (value === undefined) {
			return true;
		}
		const settingsContainingValue = dplScope.settingGroups
			.flatMap(item => item.settings)
			.filter(v => v.fieldName.toLowerCase() === key.toLowerCase())
			.filter(v => this.isValueInsideConstraint(v, value));
		return settingsContainingValue.length > 0;
	}

	private dplScopeGroupHasKeyNumericValue(dplScopeGroup: DPLConstraintGroup, key: string, value?: number) {
		if (value === undefined) {
			return true;
		}
		const settingsContainingValue = dplScopeGroup.settings
			.filter(v => v.fieldName.toLowerCase() === key.toLowerCase())
			.filter(v => this.isValueInsideConstraint(v, value));
		return settingsContainingValue.length > 0;
	}

	private isValueInsideConstraint(
		setting: { minValue: number;
			maxValue: number;
			minValueExcluded: boolean;
			maxValueExcluded: boolean; },
		value: number
	): boolean {
		const aboveMin = setting.minValueExcluded
			? setting.minValue < value
			: setting.minValue <= value;
		const belowMax = setting.maxValueExcluded
			? value < setting.maxValue
			: value <= setting.maxValue;
		return aboveMin && belowMax;
	}

	private dplScopeHasThicknessWidthPair(dplScope: DPLScopeConstraints, thickness: number, width: number) {
		const settingsContainingValue = dplScope.settingGroups
			.filter(item => this.need4steelHelperService
				.settingGroupHasCodeValuesPair(item, 'thicknessvalue', 'widthvalue', thickness, width));
		return settingsContainingValue.length > 0;
	}

	private getWidthScopeForRow(formIndex: number): WidthDplScope {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const steelgrade = String(
			(<FormControl | undefined> controlArray.controls[formIndex]?.get('steelGrade'))?.value ?? ''
		);
		const thickness = Number(
			(<FormControl | undefined> controlArray.controls[formIndex]?.get('thickness'))?.value
		);
		return this.getWidthScope(steelgrade, thickness);
	}

	private getWidthScope(steelgrade: string, thickness: number): WidthDplScope {
		const thicknessKey = Number.isNaN(thickness) ? '' : String(thickness);
		const key = `${ steelgrade }|${ thicknessKey }`;
		let scope = this.widthScopeCache.get(key);
		if (!scope) {
			scope = this.computeWidthScope(steelgrade, thickness);
			this.widthScopeCache.set(key, scope);
		}
		return scope;
	}

	private computeWidthScope(steelgrade: string, thickness: number): WidthDplScope {
		const empty: WidthDplScope = {
			mode: 'none',
			constraints: [],
			discreteValues: [],
			min: 0,
			max: 0,
			minExcluded: true,
			maxExcluded: true
		};
		if (!this.millOfferData?.dplconstraintsList || !steelgrade) {
			return empty;
		}
		const hasThickness = !Number.isNaN(thickness);

		let dplScopes = this.millOfferData.dplconstraintsList
			.filter(v => this.dplScopeHasKeyValue(v, 'steelgrade', steelgrade));
		if (hasThickness) {
			dplScopes = dplScopes.filter(v => this.dplScopeHasKeyNumericValue(v, 'thicknessvalue', thickness));
		}

		const widthConstraints = dplScopes
			.flatMap(v => v.settingGroups)
			.filter(v => !hasThickness || this.dplScopeGroupHasKeyNumericValue(v, 'thicknessvalue', thickness))
			.flatMap(item => item.settings)
			.filter(v => v.fieldName.toLowerCase() === 'widthvalue');

		if (widthConstraints.length === 0) {
			return empty;
		}

		const allDiscrete = widthConstraints.every(v => v.minValue === v.maxValue);
		const discreteValues = allDiscrete
			? [...new Set(widthConstraints.map(v => v.minValue))].sort((a, b) => a - b)
			: [];

		const widthMin = widthConstraints.reduce((prev, curr) =>
			prev.minValue > curr.minValue
			|| (prev.minValue === curr.minValue && !curr.minValueExcluded) ? curr : prev);
		const widthMax = widthConstraints.reduce((prev, curr) =>
			prev.maxValue < curr.maxValue
			|| (prev.maxValue === curr.maxValue && !curr.maxValueExcluded) ? curr : prev);

		return {
			mode: allDiscrete ? 'list' : 'range',
			constraints: widthConstraints,
			discreteValues,
			min: widthMin.minValue,
			max: widthMax.maxValue,
			minExcluded: widthMin.minValueExcluded,
			maxExcluded: widthMax.maxValueExcluded
		};
	}

	private widthInDplScopeValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const rawValue: unknown = control.value;
			if (rawValue === undefined || rawValue === null || rawValue === '') {
				return null;
			}
			const widthValue = Number(rawValue);
			if (Number.isNaN(widthValue)) {
				return null;
			}
			const rowGroup = control.parent;
			if (!rowGroup) {
				return null;
			}
			const steelgrade = String(
				(<FormControl | undefined> rowGroup.get('steelGrade'))?.value ?? ''
			);
			const thickness = Number(
				(<FormControl | undefined> rowGroup.get('thickness'))?.value
			);
			const scope = this.getWidthScope(steelgrade, thickness);
			if (scope.mode === 'none' || scope.constraints.length === 0) {
				return null;
			}
			const isAllowed = scope.constraints.some(v => this.isValueInsideConstraint(v, widthValue));
			return isAllowed ? null : { outOfDplScope: true };
		};
	}
}
